import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { RolesList } from "../../../../components/RoleManagement/Roles/List";

export interface IRolesListPage { }

export const RolesListPage: FC<IRolesListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Roles List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<RolesList />}
    />
  );
};
